import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../core/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { AbstractControl } from '@angular/forms';

export class ValidacionContrasena {

  static verificarContrasena(AC: AbstractControl) {
     let contrasena = AC.get('contrasena').value; // to get value in input tag
     let confirmarContrasena = AC.get('confirmar').value; // to get value in input tag
      if(contrasena != confirmarContrasena) {
          // console.log('false');
          AC.get('confirmar').setErrors( {verificarContrasena: true} )
      } else {
          // console.log('true');
          return null
      }
  }
}


@Component({
  selector: 'app-registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.css']
})
export class RegistroComponent implements OnInit {

  dirty = true;

  formulario: FormGroup;
  datos: any;

  cargando = false;

  mensaje: string;
  icono: string;
  clase: string;

  formErrores = {
    'email': '',
    'contrasena': '',
    'nombre': '',
    // 'confirmar': '',

  }

  mensajeError = false;
  respuesta: any;

  mensajesValidacion = {
    'email': {
      'required': 'Email obligatorio',
      'email': 'Introduzca una dirección email correcta'
    },
    'contrasena': {
      'required': 'Contraseña obligatoria',
      'pattern': 'La contraseña debe tener al menos una letra y un número ',
      'minlength': 'y más de 6 caracteres'
    },
    // 'confirmar': {
    //   'required': 'Confirma Contraseña',
    //   'pattern': 'La contraseña debe tener al menos una letra y un número ',
    //   'minlength': 'y más de 6 caracteres'
    // },
    'nombre': {
      'required': 'El Nombre es obligatorio ',
      // 'minlength': 'debe tener más de 16 caracteres'
    },
  }

  detectarCambios(data?: any) {
    if (!this.formulario) { return; }
    const form = this.formulario;
    for (const field in this.formErrores) {
      this.formErrores[field] = '';
      const control = form.get(field);
      if (control && control.dirty && !control.valid) {
        const messages = this.mensajesValidacion[field];
        for (const key in control.errors) {
          this.formErrores[field] += messages[key] + ' ';
        }
      }
    }
  }

  constructor(public snackBar: MatSnackBar, private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private activatedRouter: ActivatedRoute) { }

  ngOnInit() {
    this.formulario = this.formBuilder.group({
      'email': ['', [
        Validators.required,
        Validators.email
      ]
      ],
      'contrasena': ['', [
        Validators.required,
        Validators.pattern('^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$'),
        Validators.minLength(6)
      ]
      ],
      'confirmar': ['', [
        Validators.required,
      ]
      ],
      'nombre': ['', [
        Validators.required,
        // Validators.minLength(16)
      ]
      ]
    },
    {
      validator: ValidacionContrasena.verificarContrasena // your validation method
    }
  );
    this.formulario.valueChanges.subscribe(data => this.detectarCambios(data));
    this.detectarCambios();
  }

  // get nombre() { return this.formulario.get('nombre') }
  // get fechanac() { return this.formulario.get('fechanac') }
  // get direccion() { return this.formulario.get('direccion') }

  enviar() {
    this.cargando = true;
    this.datos = this.crearJSON();
    this.authService.registroUsuario(this.datos).then(ref => {
      this.snackBar.open('El usuario ha sido registrado correctamente, pronto serás transferido.', 'CERRAR', {
        duration: 4000
      });
      // this.mensaje = "El usuario ha sido registrado correctamente, pronto serás transferido.";
      // this.icono = "fa fa-check";
      // this.clase = "alert alert-success";
      setTimeout(() => {
        this.router.navigate(['/perfil']);
        // this.router.navigate(['perfil']);
      }, 1000);
    })
      .catch((error) => {
        this.snackBar.open('El correo electrónico ya se encuentra registrado.', 'CERRAR', {
          duration: 4000
        });
        // this.mensaje = "El correo electrónico ya se encuentra registrado.";
        // this.icono = "fa fa-exclamation";
        // this.clase = "alert alert-danger";
        this.cargando = false;
      });
  }

  crearJSON() {
    const crearJSON = {
      email: this.formulario.get('email').value,
      password: this.formulario.get('contrasena').value,
      displayName: this.formulario.get('nombre').value,
    };
    return crearJSON;
  }

  ingresarGoogle() {
    this.authService.googleLogin();
    // this.router.navigate(['/perfil'])
  }

  ingresarFacebook() {
    this.authService.facebookLogin();
    // this.router.navigate(['/perfil'])
  }

  ingresarTwitter() {
    this.authService.twitterLogin();
    // this.router.navigate(['/perfil'])
  }

}



// WEBPACK FOOTER //
// ./src/app/autenticacion/registro/registro.component.ts